import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import MyHttp from "@/config/myHttp";
import MyCrypt from "@/config/myCrypt";
import MySession from "@/config/mySession";
/*
 * 重复触发了同一个路由报错的问题
 * 它的提示是 避免到当前位置的冗余导航。 简单来说就是重复触发了同一个路由。
 * 这个错误是 vur-router更新以后新出现的错误。（我使用的是 vue-router 3.2.0）出现的 但是 （vue-router 3.0.6) 没有出现。
 * */
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

let router = new Router({
  routes: [
    {
      path: "/login",
      name: "login",
      component: resolve => require(["@/view/Login"], resolve)
    },

    {
      path: "/error",
      name: "error",
      component: resolve => require(["@/view/error"], resolve)
    },
    {
      path: "/",
      name: "Frame",
      redirect: "/homeSite",
      component: resolve => require(["@/view/Frame"], resolve), //框架页,
      meta: [],
      children: [
        {
          path: "/MarketingMerchant",
          name: "MarketingMerchant",
          component: resolve => require(["@/view/Promotion/MarketingMerchant"], resolve)
        },
        {
          path: "/homeSite",
          name: "homeSite",
          component: resolve => require(["@/view/homeSite"], resolve)
        },
        {
          path: "/MarketingService",
          name: "MarketingService",
          component: resolve => require(["@/view/Promotion/MarketingService"], resolve) //过渡页
        },
        {
          path: '/userMange',
          name: 'userMange',
          component: resolve => require(['@/view/userMange/userMange'], resolve), //过渡页
        },
        {
          path: "/MarketingBill",
          name: "MarketingBill",
          component: resolve => require(["@/view/Promotion/MarketingBill"], resolve) //过渡页
        },
        {
          path: "/infoCollect",
          name: "infoCollect",
          component: resolve => require(["@/view/infoM/infoCollect"], resolve)      //S2信息采集
        },
        {
          path: "/brushingBbnormal",
          name: "brushingBbnormal",
          component: resolve => require(["@/view/abnormalOrder/brushingBbnormal"], resolve)  //高校刷脸即付订单
        },
        {
          path: "/gmBrushingBbnormal",
          name: "gmBrushingBbnormal",
          component: resolve => require(["@/view/abnormalOrder/gmBrushingBbnormal"], resolve)  //团餐刷脸即付订单
        },
        {
          path: "/tradingStatistical",
          name: "tradingStatistical",
          component: resolve => require(["@/view/channelStatistical/tradingStatistical"], resolve)  //k12设备交易统计
        },
        {
          path: "/efficiencyStatistical",
          name: "efficiencyStatistical",
          component: resolve => require(["@/view/channelStatistical/efficiencyStatistical"], resolve)  //k12设备动销率统计
        },
        {
          path: "/equipmentStatistical",
          name: "equipmentStatistical",
          component: resolve => require(["@/view/channelStatistical/equipmentStatistical"], resolve)  //k12设备激活率统计
        },
        {
          path: "/collectionSet",
          name: "collectionSet",
          component: resolve => require(["@/view/shopCollection/collectionSet"], resolve)  //收款设置
        },
        {
          path: "/collectionGroup",
          name: "collectionGroup",
          component: resolve => require(["@/view/shopCollection/collectionGroup"], resolve)  //收款分组设置
        },
        {
          path: "/equipmentManager",
          name: "equipmentManager",
          component: resolve => require(["@/view/equipmentManager/equipmentManager"], resolve)  //设备管理
        },
        {
          path: "/formworkList",
          name: "formworkList",
          component: resolve => require(["@/view/formwork/formworkList"], resolve)  //模板列表
        },
        {
          path: "/configuration",
          name: "configuration",
          component: resolve => require(["@/view/campusActivities/configuration"], resolve)  //校园智能公话
        },
        {
          path: "/studentStatus",
          name: "studentStatus",
          component: resolve => require(["@/view/campusActivities/studentStatus"], resolve)  //学生使用状态
        },
        {
          path: "/orderManager",
          name: "orderManager",
          component: resolve => require(["@/view/campusActivities/orderManager"], resolve)  //订单管理
        },
        {
          path: "/callLog",
          name: "callLog",
          component: resolve => require(["@/view/campusActivities/callLog"], resolve)  //通话记录
        },
        {
          path: "/voiceMessage",
          name: "voiceMessage",
          component: resolve => require(["@/view/campusActivities/voiceMessage"], resolve)  //语音留言记录
        },
        {
          path: "/phoneTimeM",
          name: "phoneTimeM",
          component: resolve => require(["@/view/campusActivities/phoneTimeM"], resolve)  //电话分钟管理
        },
        {
          path:"/mallOverview",
          name:"mallOverview",
          component:resolve=>require(["@/view/ruijingMall/mallOverview"],resolve)//商城概览
        },
        {
          path: "/mallOrderQuery",
          name: "mallOrderQuery",
          component: resolve => require(["@/view/ruijingMall/mallOrderQuery"], resolve)  //商城订单查询
        },
        {
          path: "/mallPaymentDetails",
          name: "mallPaymentDetails",
          component: resolve => require(["@/view/ruijingMall/mallPaymentDetails"], resolve)  //商城支付明细
        },
        {
          path: "/mallRefundDetails",
          name: "mallRefundDetails",
          component: resolve => require(["@/view/ruijingMall/mallRefundDetails"], resolve)  //商城退款明细
        },
        {
          path: "/mallOrderManager",
          name: "mallOrderManager",
          component: resolve => require(["@/view/ruijingMall/mallOrderManager"], resolve)//订单管理
        },
        {
          path: "/mallRevenueSummary",
          name: "mallRevenueSummary",
          component: resolve => require(["@/view/ruijingMall/mallRevenueSummary"], resolve)  //商城营收汇总
        },

        {
          path: "/mallDaySummary",
          name: "mallDaySummary",
          component: resolve => require(["@/view/ruijingMall/mallDaySummary"], resolve)  //商城每日汇总
        },

        {
          path: "/balanceChange",
          name: "balanceChange",
          component: resolve => require(["@/view/ruijingMall/balanceChange"], resolve)  //余额变动
        },
        {
          path: "/gmStatistical",
          name: "gmStatistical",
          component: resolve => require(["@/view/channelStatistical/gmStatistical"], resolve)  //团餐交易数据
        },
        {
          path: "/schoolStatistical",
          name: "schoolStatistical",
          component: resolve => require(["@/view/channelStatistical/schoolStatistical"], resolve)  //高校交易数据
        },
        {
          path: "/rechargeStatistics",
          name: "rechargeStatistics",
          component: resolve => require(["@/view/ruijingMall/rechargeStatistics"], resolve)  //充值统计
        },
        {
          path: "/mallCard",
          name: "mallCard",
          component: resolve => require(["@/view/ruijingMall/mallCard"], resolve)  //商城卡密
        },
        {
          path: "/memberConsumptionStatistics",
          name: "memberConsumptionStatistics",
          component: resolve => require(["@/view/ruijingMall/memberConsumptionStatistics"], resolve)  // 会员消费统计表
        },
        {
          path: "/mallMemberRechargeTj",
          name: "mallMemberRechargeTj",
          component: resolve => require(["@/view/ruijingMall/mallMemberRechargeTj"], resolve)  // 会员充值表
        },
        {
          path: "/mallMemberCamiTj",
          name: "mallMemberCamiTj",
          component: resolve => require(["@/view/ruijingMall/mallMemberCamiTj"], resolve)  // 会员卡密抵扣表
        },
        {
          path: "/mallMemberBalanceTj",
          name: "mallMemberBalanceTj",
          component: resolve => require(["@/view/ruijingMall/mallMemberBalanceTj"], resolve)  // 会员余额统计表
        },
        {
          path: "/mallMemberAccountDetail",
          name: "mallMemberAccountDetail",
          component: resolve => require(["@/view/ruijingMall/mallMemberAccountDetail"], resolve)  // 会员账户明细  by张丽娜【2024-06-22】
        },
        {
          path: "/mallMessageMng",
          name: "mallMessageMng",
          component: resolve => require(["@/view/ruijingMall/mallMessageMng"], resolve)  // 短信发送平台  by张丽娜【2024-09-09】
        },
        {
          path: "/mallMemberActivity",
          name: "mallMemberActivity",
          component: resolve => require(["@/view/ruijingMall/mallMemberActivity"], resolve)  // 会员活跃度
        },
        {
          path: "/customerOrderStat",
          name: "customerOrderStat",
          component: resolve => require(["@/view/ruijingMall/customerOrderStat"], resolve)  // 中建商城需求-甲方报表
        },
        {
          path: "/customerOrderStatTotal",
          name: "customerOrderStatTotal",
          component: resolve => require(["@/view/ruijingMall/customerOrderStatTotal"], resolve)  // 中建商城需求-甲方报表汇总
        },
        {
          path: "/jdOrderStatKkl",
          name: "jdOrderStatKkl",
          component: resolve => require(["@/view/ruijingMall/jdOrderStatKkl"], resolve)  // 锦礼对账单-快客利
        },
        {
          path: "/jdOrderStatRj",
          name: "jdOrderStatRj",
          component: resolve => require(["@/view/ruijingMall/jdOrderStatRj"], resolve)  // 锦礼对账单-睿景
        },
        {
          path: "/mallActivityConfig",
          name: "mallActivityConfig",
          component: resolve => require(["@/view/ruijingMall/mallActivityConfig"], resolve)  // 小快活动首页配置
        },
      ]
    },

  ]
});
router.beforeEach(async (to, from, next) => {
  /**** 获取页面地址来判断合作商 start ****/
  let partnerConfig = store.state.partnerConfig;
  console.log(partnerConfig);
  if (!partnerConfig) await store.dispatch('getPartnerConfig');
  /**** 获取页面地址来判断合作商 end ****/


  if (to.path === "/error") return next();
  if (to.path === "/login") return next();

  //Smallking: add session check for login
  let ss = MySession.getSession('_gm_lgopt');
  if (!ss) {
    return next('/login');
  }
  try {
    let lg = JSON.parse(MyCrypt.$decrypt(ss));
    if (!lg.isLogin) return next('/login');
    console.log(lg)
  } catch (e) {
    return next('/login');
  }

  let user = await store.dispatch('getUser');
  // MyLog.log(`router.beforeEach: get user ${JSON.stringify(user)}`);
  // if (!user) {
  //   //get server session user
  //   let [err, data] = await MyHttp.$syncPost({ url: '/api/user/auth', data: {} });
  //   if (err) {
  //     MyLog.log(`Cors get server session user error:${err}`);
  //     return next('/error');
  //   }
  //   if (data.rst === 201 || !data) {
  //     //Jump login
  //     return next('/login');
  //   }
  //   await store.dispatch('initUser', data.user);
  // }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js